import { createPopper } from "@popperjs/core";

export default class NumberToolTip {
    private numbersWrapper: HTMLElement[] | null;

    constructor() {
        this.numbersWrapper = [...document.querySelectorAll<HTMLElement>(".numbers-item--content")];

        this.init();
    }

    public init = async (): Promise<void> => {
        if (!this.numbersWrapper) return;

        this.numbersWrapper.forEach(this.createToolTip);
    };

    private createToolTip = (item) => {
        const dot = item.querySelector(".circle-line") as HTMLElement;
        const numberWrapper = item.querySelector(".number-content") as HTMLElement;

        if (!dot) return;
        if (!numberWrapper) return;

        createPopper(dot, numberWrapper, {
            placement: "bottom-start",
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [8, 6],
                    },
                },
                {
                    name: "flip",
                    enabled: false,
                },
            ],
        });
    };
}
